import React, { useState } from "react";
import Table from "../../modules/layout/Table";

import AdminModalQuestion from "../../modules/admin/AdminModalQuestion";

const AdminQuestionTable = () => {
  return (
    <>
      <div className="height-modify" style={{ marginBottom: "20px" }}>
        <Table
          header={["No.", "문항", "준비시간(s)", "최소응답(s)", "최대응답(s)"]}
        >
          <AdminModalQuestion questionNumber={1} />
          <AdminModalQuestion questionNumber={2} />
          <AdminModalQuestion questionNumber={3} />
        </Table>
      </div>
    </>
  );
};

export default AdminQuestionTable;
